export default __webpack_public_path__ + "static/media/staff7.ba345913.jpg";